module.exports = __webpack_public_path__ + "img/lestrade_card.41587fe5.png";